
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCrane as ObiCraneElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-crane.js';
 
 
 

 
 export const ObiCrane = createComponent({
   react: React,
   tagName: 'obi-crane',
   elementClass: ObiCraneElement,
   events: {
     
   }
  });
 
 